import { render, staticRenderFns } from "./ProfileGrades.vue?vue&type=template&id=63c57dda&scoped=true&"
import script from "./ProfileGrades.vue?vue&type=script&lang=js&"
export * from "./ProfileGrades.vue?vue&type=script&lang=js&"
import style0 from "./ProfileGrades.vue?vue&type=style&index=0&id=63c57dda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c57dda",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('63c57dda', component.options)
    } else {
      api.reload('63c57dda', component.options)
    }
    module.hot.accept("./ProfileGrades.vue?vue&type=template&id=63c57dda&scoped=true&", function () {
      api.rerender('63c57dda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/student-profile/components/grades/ProfileGrades.vue"
export default component.exports